// Profile-related option constants

/**
 * @typedef {{ code: string, name: string }} Option
 */

/** @type {Option[]} */
export const AVAILABLE_LANGUAGES = [
  { code: 'en', name: 'English' },
  { code: 'es', name: 'Spanish' },
  { code: 'fr', name: 'French' },
  { code: 'de', name: 'German' },
  { code: 'pt', name: 'Portuguese' },
  { code: 'ru', name: 'Russian' },
  { code: 'ja', name: 'Japanese' },
  { code: 'ko', name: 'Korean' },
  { code: 'zh', name: 'Chinese' },
  { code: 'it', name: 'Italian' },
  { code: 'nl', name: 'Dutch' },
  { code: 'pl', name: 'Polish' },
  { code: 'tr', name: 'Turkish' },
  { code: 'ar', name: 'Arabic' },
  { code: 'hi', name: 'Hindi' },
  { code: 'th', name: 'Thai' },
  { code: 'vi', name: 'Vietnamese' },
  { code: 'sv', name: 'Swedish' },
  { code: 'no', name: 'Norwegian' },
  { code: 'da', name: 'Danish' }
];

/** @type {Option[]} */
export const GAME_GENRES = [
  { code: 'shooter', name: 'Shooter' },
  { code: 'racer', name: 'Racing' },
  { code: 'vs', name: 'Versus/Fighting' },
  { code: 'rpg', name: 'RPG' },
  { code: 'mmo', name: 'MMO' },
  { code: 'moba', name: 'MOBA' },
  { code: 'strategy', name: 'Strategy' },
  { code: 'survival', name: 'Survival' },
  { code: 'sports', name: 'Sports' },
  { code: 'sandbox', name: 'Sandbox' },
];

/** @type {Option[]} */
export const PLATFORMS = [
  { code: 'pc', name: 'PC' },
  { code: 'ps', name: 'PlayStation' },
  { code: 'xbox', name: 'Xbox' },
  { code: 'switch', name: 'Nintendo Switch' },
  { code: 'mobile', name: 'Mobile' },
  { code: 'vr', name: 'VR' },
  { code: 'retro', name: 'Retro/Emulation' },
];

/** @type {Option[]} */
// Continents and countries are lazy-loaded from the mledoze dataset at runtime.


